// Generated automatically by the "build:css-postfix" script
export var cssPostfix = 'c59259b';